import {KTCard} from '../../../_metronic/helpers'
import {SalesRepTypeReportContext} from '../context'
import useGetSalesRepTypeReport from '../hooks/useGetSalesRepTypeReport'
import SalesRepTypeReportTable from '../sections/table/SalesRepTypeReportTable'
import useGetSalesRepTypeDropdown from '../hooks/useGetSalesRepTypeDropdown'
import {CustomerRepTypeReportHeader} from '../sections/header/CustomerRepTypeReportHeader'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
function SalesRepTypeReport() {
  const {
    reportData: salesRepTypeData,
    isLoading: isSalesRepTypeLoading,
    filters: salesRepTypeFilters,
    onSortingChange: onSalesRepTypeSortingChange,
    handleSalesRepTypeReportDateChange,
    onChangeSalesRepTypeFilter,
  } = useGetSalesRepTypeReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('sales_rep_type')

  const {salesRepTypes, isLoading: isSalesRepDropdownLoading} = useGetSalesRepTypeDropdown()

  const contextValue = {
    salesRepTypeData,
    isSalesRepTypeLoading,
    salesRepTypeFilters,
    onSalesRepTypeSortingChange,
    handleSalesRepTypeReportDateChange,
    onChangeSalesRepTypeFilter,

    salesRepTypes,
    isSalesRepDropdownLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  }

  return (
    <KTCard>
      <SalesRepTypeReportContext.Provider value={contextValue}>
        <CustomerRepTypeReportHeader />
        <SalesRepTypeReportTable />
      </SalesRepTypeReportContext.Provider>
    </KTCard>
  )
}

export default SalesRepTypeReport
